import React, { useEffect, useState, useRef } from 'react';
import { addDays, format,isSameDay } from 'date-fns';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import elLocale from '@fullcalendar/core/locales/el';
import AppointmentModal from './AppointmentModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import { el } from 'date-fns/locale';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { toast } from 'react-toastify';
import CardEvent from './CardEvent'; // πάνω-πάνω
import { ChevronLeft, ChevronRight } from "./RemindlyIcons";

registerLocale('el', el);

const API = "http://127.0.0.1:8080";

const FullCalendarPerEmployee = () => {
  
  const calendarRefs = useRef({});
  const [isDragging, setIsDragging] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [viewMode, setViewMode] = useState('day');
  const isToday = isSameDay(selectedDate, new Date());
  const calendarRef = useRef(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedEmployeeIdForFilter, setSelectedEmployeeIdForFilter] = useState('all');

  // ✅ Προσθήκη: ενεργοί υπάλληλοι & δυναμικές στήλες για το grid
  const activeEmployees = employees.filter(e => e.active === true || e.active === 1);
  const gridColsClass =
    activeEmployees.length <= 1 ? 'grid-cols-1' :
    activeEmployees.length === 2 ? 'grid-cols-2' :
    activeEmployees.length === 3 ? 'grid-cols-3' :
    activeEmployees.length === 4 ? 'grid-cols-4' :
    'grid-cols-5';

  // 📌 Σωστή θέση — πριν το return και έξω από άλλες συναρτήσεις
  useEffect(() => {
    const calendarApi = calendarRef.current?.getApi();
    if (!calendarApi) return;

    const view =
      viewMode === 'day' ? 'timeGridDay' :
      viewMode === 'week' ? 'timeGridWeek' :
      'dayGridMonth';

    calendarApi.changeView(view);
    calendarApi.gotoDate(selectedDate);
  }, [viewMode, selectedDate]);

  useEffect(() => {
    fetch(`${API}/employees`)

      .then(async (res) => {
        const data = await res.json();
        console.log("📥 Employees response:", data);

        if (!Array.isArray(data)) {
          console.error("❌ Δεν επιστράφηκε πίνακας:", data);
          return;
        }


  const employeesWithSchedules = data; // schedule already included

        setEmployees(employeesWithSchedules);
        fetchAppointments(employeesWithSchedules);
      })
      .catch((err) => {
        console.error("❌ Σφάλμα στο fetch employees:", err);
      });
  }, []);

  useEffect(() => {
    // sync κεντρικού calendar (week/month)
    if (calendarRef.current) {
      calendarRef.current.getApi().gotoDate(selectedDate);
    }

    // sync όλων των calendars των υπαλλήλων (day view)
    Object.values(calendarRefs.current).forEach((ref) => {
      if (ref && ref.getApi) {
        ref.getApi().gotoDate(selectedDate);
      }
    });
  }, [selectedDate]);

  const fetchAppointments = (empList = employees) => {
    fetch(`${API}/appointments`)
    
      .then(res => {
        if (!res.ok) {
          throw new Error(`Server error: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        console.log("📦 appointments response:", data); // 👈 ΠΡΟΣΘΗΚΗ
        const formatted = data.map(a => {
          console.log('📦 a:', a);
          const emp = empList.find(e => String(e.id) === String(a.employee_id)) || {};
          return {
            id: a.id,
            title: `${(a.customer || '').trim()} – ${(a.service || '').trim()}`,
            start: a.start_time,  // ──▶ Python already returns ISO format
            end: a.end_time,
            employee_id: a.employee_id,
            customer_id: a.customer_id,
            service_id: a.service_id,
            status: a.status,
            send_sms: Boolean(Number(a.wants_sms)),
            send_email: Boolean(Number(a.wants_email)),
            backgroundColor: emp.color || '#607d8b',
            borderColor: emp.color || '#607d8b',
            textColor: '#fff'
          };
        });
        setAppointments(formatted);
      })
      .catch(err => {
        console.error("❌ fetchAppointments error:", err);
      });
  };

const handleTooltip = (info) => {
  if (isDragging) return;

  const [customer, service] = (info.event.title || '').split(' – ');
  const formatTime = (date) =>
    `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
  const startTime = formatTime(new Date(info.event.start));
  const endTime = formatTime(new Date(info.event.end));

  if (info.el._tippy) {
    info.el._tippy.destroy();
  }

  setTimeout(() => {
    tippy(info.el, {
      content: `
        <div class="tooltip-content px-3 py-2 text-sm">
          <div><strong>Πελάτης:</strong> ${customer || ''}</div>
          <div><strong>Υπηρεσία:</strong> ${service || ''}</div>
          <div><strong>Ώρα:</strong> ${startTime} - ${endTime}</div>
        </div>
      `,
      allowHTML: true,
      placement: 'top',
      animation: 'scale',
      theme: 'tailwind',
      delay: [300, 0],
      offset: [0, 10],
    });
  }, 0);
};


  const formatDateTimeLocal = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
  };

const handleEventResize = (info) => {
  const event = info.event;
  const id = event.id;
  const newStart = new Date(event.start);
  const newEnd = new Date(event.end);
  const employeeId = event.extendedProps.employee_id;

  const newStartStr = formatDateTimeLocal(newStart);
  const newEndStr = formatDateTimeLocal(newEnd);

    fetch(`${API}/appointments/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id,
      employee_id: employeeId,
      start_time: newStartStr,
      end_time: newEndStr,
    }),
  })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        fetchAppointments(); // refresh
        toast.success("Η διάρκεια ενημερώθηκε");

        // ✅ Ενημέρωση tooltip μετά το resize
        if (info.el && info.el._tippy) {
          info.el._tippy.destroy();
        }

        const [customer, service] = (event.title || '').split(' – ');
        const formatTime = (date) =>
          `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
        const startTime = formatTime(new Date(event.start));
        const endTime = formatTime(new Date(event.end));

        setTimeout(() => {
          tippy(info.el, {
            content: `
              <div class="tooltip-content px-3 py-2 text-sm">
                <div><strong>Πελάτης:</strong> ${customer || ''}</div>
                <div><strong>Υπηρεσία:</strong> ${service || ''}</div>
                <div><strong>Ώρα:</strong> ${startTime} - ${endTime}</div>
              </div>
            `,
            allowHTML: true,
            placement: 'top',
            animation: 'scale',
            theme: 'tailwind',
            delay: [300, 0],
            offset: [0, 10],
          });
        }, 0);
      } else {
        toast.error("❌ Σφάλμα στην αποθήκευση");
        info.revert();
      }
    })
    .catch(() => {
      toast.error("❌ Σφάλμα δικτύου");
      info.revert();
    });
};


  const handleEventDrop = (info) => {
    const event = info.event;
    const id = event.id;
    const newStart = new Date(event.start);
    const newEnd = new Date(event.end);
    const newEmployeeId = event.extendedProps.employee_id;

    // 👇 Inline ώστε να έχει πρόσβαση στο τρέχον appointments
    const isOverlapping = (start, end, currentId, employeeId) => {
      return appointments.some(app => {
        if (String(app.id) === String(currentId)) return false;
        if (String(app.employee_id) !== String(employeeId)) return false;

        const existingStart = new Date(app.start);
        const existingEnd = new Date(app.end);

        return (
          (start >= existingStart && start < existingEnd) ||
          (end > existingStart && end <= existingEnd) ||
          (start <= existingStart && end >= existingEnd)
        );
      });
    };

    if (isOverlapping(newStart, newEnd, id, newEmployeeId)) {
      toast.error("Υπάρχει ήδη ραντεβού σε αυτή τη χρονική περίοδο.");
      info.revert();
      return;
    }

    const newStartStr = formatDateTimeLocal(newStart);
    const newEndStr = formatDateTimeLocal(newEnd);

    fetch(`${API}/appointments/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id,
        start_time: newStartStr,
        end_time: newEndStr,
        employee_id: newEmployeeId
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          toast.success("Το ραντεβού μετακινήθηκε!");
          fetchAppointments();
          // Καταστροφή παλιού tooltip (αν υπάρχει)
          if (info.el && info.el._tippy) {
            info.el._tippy.destroy();
          }
          // Επανενεργοποίηση tooltip
          setTimeout(() => {
            const [customer, service] = (event.title || '').split(' – ');
            const formatTime = (date) =>
              `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
            const startTime = formatTime(event.start);
            const endTime = formatTime(event.end);

            tippy(info.el, {
              content: `
                <div class="tooltip-content px-3 py-2 text-sm">
                  <div><strong>Πελάτης:</strong> ${customer || ''}</div>
                  <div><strong>Υπηρεσία:</strong> ${service || ''}</div>
                  <div><strong>Ώρα:</strong> ${startTime} - ${endTime}</div>
                </div>
              `,
              allowHTML: true,
              placement: 'top',
              animation: 'scale',
              theme: 'tailwind',
              delay: [300, 0],
              offset: [0, 10],
            });
          }, 0);

          // Tooltip ενημέρωση
          if (info.el && info.el._tippy) {
            info.el._tippy.destroy();
          }

          const [customer, service] = (event.title || '').split(' – ');
          const startTime = newStartStr.slice(11, 16);
          const endTime = newEndStr.slice(11, 16);

          setTimeout(() => {
            tippy(info.el, {
              content: `
                <div class="tooltip-content px-3 py-2 text-sm">
                  <div><strong>Πελάτης:</strong> ${customer || ''}</div>
                  <div><strong>Υπηρεσία:</strong> ${service || ''}</div>
                  <div><strong>Ώρα:</strong> ${startTime} - ${endTime}</div>
                </div>
              `,
              allowHTML: true,
              placement: 'top',
              animation: 'scale',
              theme: 'tailwind',
              delay: [300, 0],
              offset: [0, 10],
            });
          }, 0);
        } else {
          alert("❌ Σφάλμα στην ενημέρωση");
          info.revert();
        }
      })
      .catch(() => {
        alert("❌ Σφάλμα δικτύου");
        info.revert();
      });
  };

  const handleEventClick = ({ event }) => {
    const emp = employees.find(e => String(e.id) === String(event.extendedProps.employee_id));
    const [customer, service] = (event.title || '').split(' – ');
    setSelectedEmployee(emp);
    setSelectedSlot({ start: event.start });
    setSelectedAppointment({
      id: event.id,
      start: event.start,
      end: event.end,
      send_sms: event.extendedProps.send_sms,
      send_email: event.extendedProps.send_email,
      employee_id: event.extendedProps.employee_id,
      customer_id: event.extendedProps.customer_id,
      service_id: event.extendedProps.service_id,
      customer: customer || '',
      service: service || '',
      status: event.extendedProps.status || '' // ✅ ΠΡΟΣΘΗΚΗ
    });

    setModalOpen(true);
  };

  const handleDateClick = (info, employee = null) => {
    setSelectedSlot(info);
    setSelectedEmployee(employee);
    setSelectedAppointment(null);
    setModalOpen(true);
  };

const renderEventCard = (arg) => {
  return (
    <CardEvent
      title={arg.event.title}
      timeText={arg.timeText}
      borderColor={arg.event.borderColor}
      viewType={arg.view.type}
      start={arg.event.start}
      end={arg.event.end}
      status={arg.event.extendedProps.status} // ✅ Προσθήκη
    />
  );
};



  const handleEventMove = (info, newEmployeeId) => {
    const event = info.event;
    const newStart = formatDateTimeLocal(event.start);
    const newEnd = formatDateTimeLocal(event.end);

    const payload = {
      id: event.id,
      employee_id: newEmployeeId,
      customer_id: event.extendedProps.customer_id,
      service_id: event.extendedProps.service_id,
      start_time: newStart,
      end_time: newEnd,
    };

    fetch(`${API}/appointments/${payload.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          toast.success("Το ραντεβού μετακινήθηκε!");
          fetchAppointments();

          // Ενημέρωση tooltip
          if (info.el && info.el._tippy) {
            info.el._tippy.destroy();
          }

          const [customer, service] = (event.title || '').split(' – ');
          const formatTime = (date) =>
            `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
          const startTime = formatTime(event.start);
          const endTime = formatTime(event.end);

          tippy(info.el, {
            content: `
              <div class="tooltip-content px-3 py-2 text-sm">
                <div><strong>Πελάτης:</strong> ${customer || ''}</div>
                <div><strong>Υπηρεσία:</strong> ${service || ''}</div>
                <div><strong>Ώρα:</strong> ${startTime} - ${endTime}</div>
              </div>
            `,
            allowHTML: true,
            placement: 'top',
            animation: 'scale',
            theme: 'tailwind',
            delay: [300, 0],
            offset: [0, 10],
          });

        } else {
          alert("❌ Σφάλμα κατά την ενημέρωση");
          info.revert();
        }
      })
      .catch(() => {
        alert("❌ Σφάλμα δικτύου");
        info.revert();
      });
  };

  const formatHeaderDate = () => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return selectedDate.toLocaleDateString('el-GR', options);
  };

  const formatWeekRange = () => {
    const start = selectedDate;
    const end = addDays(selectedDate, 6);
    return `${format(start, 'd')} – ${format(end, 'd MMMM yyyy', { locale: el })}`;
  };

  return (
    <>
      <div className="relative border-b bg-white px-4 py-2">
        {/* 📆 Ημερομηνία κεντραρισμένη */}
        <div
          className="text-center font-semibold text-lg cursor-pointer select-none"
          onClick={() => setShowDatePicker(prev => !prev)}
        >
          {viewMode === 'week'
            ? formatWeekRange()
            : viewMode === 'month'
            ? format(selectedDate, 'LLLL yyyy', { locale: el })
            : format(selectedDate, 'd MMMM yyyy', { locale: el })}
        </div>

        {/* ⬅️ Σήμερα ➡️ buttons */}
        <div className="mt-2 flex justify-center items-center gap-2">
          <button
            onClick={() => {
              const offset = viewMode === 'day' ? -1 : viewMode === 'week' ? -7 : -30;
              setSelectedDate(addDays(selectedDate, offset));
            }}
            className="w-8 h-8 border border-gray-300 rounded flex items-center justify-center hover:bg-gray-100 text-gray-700"
            title="Προηγούμενη"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>

          <button
            onClick={() => setSelectedDate(new Date())}
            disabled={isToday}
            className={`px-4 py-1 rounded-full font-medium text-sm transition ${
              isToday
                ? 'bg-indigo-600 text-white cursor-default'
                : 'border border-gray-300 text-gray-800 hover:bg-indigo-100'
            }`}
          >
            Σήμερα
          </button>

          <button
            onClick={() => {
              const offset = viewMode === 'day' ? 1 : viewMode === 'week' ? 7 : 30;
              setSelectedDate(addDays(selectedDate, offset));
            }}
            className="w-8 h-8 border border-gray-300 rounded flex items-center justify-center hover:bg-gray-100 text-gray-700"
            title="Επόμενη"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>

        {/* 📅 DatePicker */}
        {showDatePicker && (
          <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2 z-50">
            <DatePicker
              selected={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);
                calendarRef.current?.getApi().gotoDate(date);
                setShowDatePicker(false);
              }}
              inline
              locale="el"
              calendarClassName="shadow-lg border border-gray-200 rounded bg-white"
            />
          </div>
        )}

        {/* 🔽 View & Filter Controls */}
        <div className="mt-4 flex flex-col sm:flex-row sm:items-center items-stretch justify-center sm:justify-end gap-2 w-full">
          {/* 🔽 Dropdown υπαλλήλων — μόνο σε week/month */}
          {viewMode !== 'day' && (
            <select
              className="border border-gray-300 rounded-full px-3 py-1 text-sm"
              value={selectedEmployeeIdForFilter}
              onChange={(e) => setSelectedEmployeeIdForFilter(e.target.value)}
            >
              <option value="all">Όλοι οι υπάλληλοι</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.name}
                </option>
              ))}
            </select>
          )}

          {/* 🗓 Κουμπιά αλλαγής view */}
          <div className="flex justify-center sm:justify-end gap-2">
            {['day', 'week', 'month'].map((mode) => (
              <button
                key={mode}
                onClick={() => setViewMode(mode)}
                className={`px-3 py-1 rounded-full text-sm transition ${
                  viewMode === mode
                    ? 'bg-indigo-600 text-white'
                    : 'border border-gray-300 text-gray-700 hover:bg-gray-100'
                }`}
              >
                {mode === 'day' ? 'Ημέρα' : mode === 'week' ? 'Εβδομάδα' : 'Μήνας'}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Calendar Grid Start */}
      <div className="p-4">
        {viewMode === 'day' ? (
          <div className={`p-4 bg-gray-50 grid ${gridColsClass} gap-4`}>
            {activeEmployees.map(emp => {
              
              const empEvents = appointments.filter(e =>
                String(e.employee_id) === String(emp.id) &&
                format(new Date(e.start), 'yyyy-MM-dd') === format(selectedDate, 'yyyy-MM-dd')
              );

              // 💤 Δημιουργία background events για ρεπό
              const dayMap = {
                sunday: 0,
                monday: 1,
                tuesday: 2,
                wednesday: 3,
                thursday: 4,
                friday: 5,
                saturday: 6,
              };

              // Πρώτα βρίσκουμε τις ημέρες ρεπό
              const offDays = (emp.schedule || [])
                .filter(d => !d.start_time && !d.end_time)
                .map(d => dayMap[d.day_of_week]);

              // Έπειτα ελέγχουμε αν η σημερινή ημέρα είναι ρεπό
              const isDayOff = offDays.includes(selectedDate.getDay());

              // Και τέλος δημιουργούμε το background event
              const offDayEvents = isDayOff
                ? [{
                    start: format(selectedDate, 'yyyy-MM-dd') + 'T00:00:00',
                    end: format(selectedDate, 'yyyy-MM-dd') + 'T23:59:00',
                    display: 'background',
                    backgroundColor: '#f3f4f6',
                    allDay: false
                  }]
                : [];

              // ✅ Δημιουργία background events για εκτός ωραρίου
              const currentDayName = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'][selectedDate.getDay()];

              // Βρες το ωράριο της ημέρας (αν υπάρχει)
              const todaySchedule = (emp.schedule || [])
                .filter(d => d.day_of_week === currentDayName && d.start_time && d.end_time)
                .sort((a, b) => a.start_time.localeCompare(b.start_time));

              // Αν δεν έχει ωράριο → όλη μέρα εκτός
              const unavailableBlocks = [];
              const openDay = "09:00";
              const closeDay = "22:00";

              if (todaySchedule.length === 0) {
                unavailableBlocks.push({ start: openDay, end: closeDay });
              } else {
                // Πριν την πρώτη βάρδια
                if (todaySchedule[0].start_time > openDay)
                  unavailableBlocks.push({ start: openDay, end: todaySchedule[0].start_time });

                // Μεταξύ βαρδιών
                for (let i = 0; i < todaySchedule.length - 1; i++) {
                  unavailableBlocks.push({
                    start: todaySchedule[i].end_time,
                    end: todaySchedule[i + 1].start_time
                  });
                }

                // Μετά την τελευταία βάρδια
                if (todaySchedule[todaySchedule.length - 1].end_time < closeDay)
                  unavailableBlocks.push({
                    start: todaySchedule[todaySchedule.length - 1].end_time,
                    end: closeDay
                  });
              }

              // Μετατροπή σε background events (γκρι)
              const unavailableEvents = unavailableBlocks.map(b => ({
                start: `${format(selectedDate, 'yyyy-MM-dd')}T${b.start}:00`,
                end: `${format(selectedDate, 'yyyy-MM-dd')}T${b.end}:00`,
                display: "background",
                backgroundColor: "#717785",         // διάφανο φόντο
                borderColor: "#ef4444",          // κόκκινο περίγραμμα
                borderLeft: "1px solid #ef4444", // κάθετη κόκκινη γραμμή
                rendering: "background",
                classNames: ["unavailable-slot"], // για CSS έλεγχο
              }));

              return (
                <div
                  key={emp.id}
                  className={`bg-white shadow rounded border border-gray-200 relative ${
                    isDayOff ? "cursor-not-allowed opacity-90" : ""
                  }`}
                >
                  {/* Header με όνομα & ένδειξη ρεπό */}
                  <div
                    className={`p-2 font-semibold text-center rounded-t flex justify-center items-center gap-2 ${
                      isDayOff ? "bg-gray-200 text-gray-500 italic" : "text-white"
                    }`}
                    style={isDayOff ? {} : { backgroundColor: emp.color }}
                  >
                    {emp.name}
                    {isDayOff && (
                      <span className="ml-1 text-sm bg-gray-100 text-gray-600 px-2 py-0.5 rounded">
                        Ρεπό
                      </span>
                    )}
                  </div>

                  {/* FullCalendar wrapper */}
                  <div className={isDayOff ? "pointer-events-none" : ""}>
                    <FullCalendar
                      plugins={[timeGridPlugin, interactionPlugin]}
                      editable={!isDayOff}
                      selectable={!isDayOff} // ✅ επιτρέπει επιλογές μόνο αν δεν είναι ρεπό
                      eventDurationEditable={!isDayOff}
                      eventResize={!isDayOff ? handleEventResize : undefined}
                      droppable={!isDayOff}
                      initialView="timeGridDay"
                      initialDate={selectedDate}
                      headerToolbar={false}
                      allDaySlot={false}
                      slotMinTime="09:00:00"
                      slotMaxTime="22:00:00"
                      slotDuration="00:30:00"
                      events={[...empEvents, ...offDayEvents, ...unavailableEvents]}
                      nowIndicator
                      height={1000}
                      locale={elLocale}
                      ref={(el) => { calendarRefs.current[emp.id] = el; }}
                      eventContent={renderEventCard}
                      eventClick={!isDayOff ? handleEventClick : undefined}
                      eventDidMount={!isDayOff ? handleTooltip : undefined}

                      /* ✅ Κλικ σε slot */
                      dateClick={(info) => {
                        if (isDayOff) return;

                        const clickTime = format(info.date, 'HH:mm');
                        const isInUnavailable = unavailableBlocks.some(
                          (b) => clickTime >= b.start && clickTime < b.end
                        );

                        if (isInUnavailable) {
                          toast.warn("Εκτός ωραρίου εργασίας!");
                          return; // ❌ Μην ανοίξεις modal
                        }

                        // ✅ Αν είναι εντός ωραρίου
                        handleDateClick({ start: info.date }, emp);
                      }}

                      /* ✅ Επιλογή (drag) */
                      // select={(info) => {
                      //   if (isDayOff) return;

                      //   const clickTime = format(info.start, 'HH:mm');
                      //   const isInUnavailable = unavailableBlocks.some(
                      //     (b) => clickTime >= b.start && clickTime < b.end
                      //   );

                      //   if (isInUnavailable) {
                      //     toast.warn("Εκτός ωραρίου εργασίας!");
                      //     return; // ❌ Μην ανοίξεις modal
                      //   }

                      //   // ✅ Αν είναι εντός ωραρίου
                      //   handleDateClick(info, emp);
                      // }}

                      eventDrop={!isDayOff ? (info) => handleEventMove(info, emp.id) : undefined}
                      eventReceive={!isDayOff ? (info) => handleEventMove(info, emp.id) : undefined}
                      eventDragStart={() => setIsDragging(true)}
                      eventDragStop={() => setIsDragging(false)}
                      eventAllow={(dropInfo, draggedEvent) => {
                        if (isDayOff) return false;

                        const draggedId = draggedEvent.id;
                        const dropStart = new Date(dropInfo.start);
                        const dropEnd = new Date(dropInfo.end);
                        const targetEmployeeId = emp.id;

                        const hasConflict = appointments.some((app) => {
                          if (String(app.id) === String(draggedId)) return false;
                          if (String(app.employee_id) !== String(targetEmployeeId)) return false;

                          const existingStart = new Date(app.start);
                          const existingEnd = new Date(app.end);

                          return (
                            (dropStart >= existingStart && dropStart < existingEnd) ||
                            (dropEnd > existingStart && dropEnd <= existingEnd) ||
                            (dropStart <= existingStart && dropEnd >= existingEnd)
                          );
                        });

                        if (hasConflict) {
                          toast.warn("⚠️ Υπάρχει ήδη ραντεβού σε αυτή την ώρα!");

                          return false;
                        }

                        // ✅ Απαγόρευση drop σε εκτός ωραρίου
                        const dropTime = format(dropInfo.start, "HH:mm");
                        const isUnavailable = unavailableBlocks.some(
                          b => dropTime >= b.start && dropTime < b.end
                        );
                        if (isUnavailable) {
                          toast.warn("Εκτός ωραρίου εργασίας!");
                          return false;
                        }

                        return true;
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ) : (

        <>

          {/* 🔽 Εβδομαδιαίο ή Μηνιαίο FullCalendar */}
          <FullCalendar
            eventDragStart={() => setIsDragging(true)}
            eventDragStop={() => setIsDragging(false)}
            plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
            initialView={
              viewMode === 'week' ? 'timeGridWeek' :
              viewMode === 'month' ? 'dayGridMonth' :
              'timeGridDay'
            }
            editable={true}
            eventDurationEditable={true}
            eventResize={handleEventResize} 
            droppable={false}
            eventDrop={handleEventDrop}
            headerToolbar={false}
            ref={calendarRef}
            initialDate={selectedDate}
            slotMinTime="09:00:00"
            slotMaxTime="22:00:00"
            locale={elLocale}
            nowIndicator
            height={1000}
            events={
              selectedEmployeeIdForFilter === 'all'
                ? appointments
                : appointments.filter(app =>
                    String(app.employee_id) === String(selectedEmployeeIdForFilter)
                  )
            }
            eventDidMount={handleTooltip}
            eventClick={handleEventClick}
            select={(info) => setSelectedSlot(info)}
            eventContent={renderEventCard}
          />
        </>
        )}
      </div>

<AppointmentModal
  isOpen={modalOpen}
  onClose={() => {
    setModalOpen(false);
    setSelectedAppointment(null);
  }}
  onSaved={() => {
    // ✅ Κάνε refresh στα appointments
    fetchAppointments();

    // ✅ Μόλις αποδοθούν, ενημέρωσε τα tooltips για το νέο status
    setTimeout(() => {
      document.querySelectorAll('.fc-event').forEach((el) => {
        const eventId = el.getAttribute('data-event-id');
        const app = appointments.find(a => String(a.id) === String(eventId));
        if (!app) return;

        const [customer, service] = (app.title || '').split(' – ');
        const statusText =
          app.status === 'cancelled' ? '❌ Ακυρώθηκε' :
          app.status === 'no_show' ? '🚫 Δεν ήρθε' :
          '✅ Ολοκληρώθηκε';

        const startTime = new Date(app.start).toLocaleTimeString('el-GR', { hour: '2-digit', minute: '2-digit' });
        const endTime = new Date(app.end).toLocaleTimeString('el-GR', { hour: '2-digit', minute: '2-digit' });

        if (el._tippy) el._tippy.destroy();

        tippy(el, {
          content: `
            <div class="tooltip-content px-3 py-2 text-sm">
              <div><strong>Πελάτης:</strong> ${customer || ''}</div>
              <div><strong>Υπηρεσία:</strong> ${service || ''}</div>
              <div><strong>Κατάσταση:</strong> ${statusText}</div>
              <div><strong>Ώρα:</strong> ${startTime} - ${endTime}</div>
            </div>
          `,
          allowHTML: true,
          placement: 'top',
          animation: 'scale',
          theme: 'tailwind',
          delay: [300, 0],
          offset: [0, 10],
        });
      });
    }, 400);
  }}

        slotInfo={selectedSlot}
        employee={selectedEmployee}
        appointment={selectedAppointment}
        appointments={appointments}
        setSelectedAppointment={setSelectedAppointment} // ✅ ΠΡΟΣΘΗΚΗ
      />

    </>
  );
};

export default FullCalendarPerEmployee;
